import Joi from "joi-browser";

let schema = Joi.object().keys({
  username: Joi.string().required(),
  password: Joi.string().required(),
});
schema = schema.optionalKeys("username", "password");
export default schema;
